import React from "react";
import { NoDataAvailableDiv } from "components/NoDataAvailableDiv";
import { Panel } from "components/panels/index";
import FavoriteSubjectPanel from "./favoritesubjectpanel";
import PanelSegmentType from "components/panels/PanelSegment/PanelSegment";

interface State {
  subjects: server.dto.FavoriteSubject[]
  isLoading: boolean
  editingSubject?: server.dto.FavoriteSubject
  creatingSubject?: server.dto.FavoriteSubject
}

class FavoriteSubjects extends React.Component<unknown, State> {
  state: State = {
    subjects: [],
    isLoading: true,
    editingSubject: null,
    creatingSubject: null
  };

  componentDidMount() {
    document.title = RESX.GeneralLabels.MaintainSubjects;

    window.CoreApi.FavoriteSubject.ListSubjects()
      .then(res => { this.setState({ subjects: res.data?.data || [] }); })
      .finally(() => { this.setState({ isLoading: false }); });
  }

  onNewClick = () => {
    const defaultSubject: server.dto.FavoriteSubject = {
      subjectId: 0,
      subjectValue: ""
    };
    this.setState({ creatingSubject: defaultSubject });
  };

  onEditClick = (existingSubject: server.dto.FavoriteSubject) => {
    this.setState({ editingSubject: existingSubject });
  };

  onSave = async (subject: server.dto.FavoriteSubject) => {
    const resp = await window.CoreApi.FavoriteSubject.UpdateSubject(subject);
    if (resp.data.hasErrors) {
      return;
    }
    this.setState({ subjects: resp.data.data, editingSubject: null });
  };

  onCreate = async (subject: server.dto.FavoriteSubject) => {
    const resp = await window.CoreApi.FavoriteSubject.CreateSubject(subject)
    if (resp.data.hasErrors) {
      return;
    }
    this.setState({ subjects: resp.data.data, creatingSubject: null });
  };

  onDeleteClick = (subject: server.dto.FavoriteSubject) => {
    window.CoreApi.FavoriteSubject.DeleteSubject(subject.subjectId)
      .then(() => {
        const newList = this.state.subjects.filter(s => s.subjectId !== subject.subjectId);
        this.setState({ subjects: newList });
      });
  };

  shouldShowNoDataAvailable = () => {
    return this.state.subjects.length === 0 && !this.state.creatingSubject;
  };

  public render(): JSX.Element {
    return (
      <>
        <PanelSegmentType>
          <PanelSegmentType.Header size="h1header">
            <PanelSegmentType.Title title={RESX.GeneralLabels.MaintainSubjects} />
            <PanelSegmentType.Button onClick={this.onNewClick} label={RESX.GeneralLabels.resxNew} type="primary" />
          </PanelSegmentType.Header>
        </PanelSegmentType>

        <Panel
          panelClassName="s1_listview-panel"
          isLoading={this.state.isLoading}
        >
          {this.shouldShowNoDataAvailable()
            ? (
              <NoDataAvailableDiv />
            )
            : (
              <FavoriteSubjectPanel
                onEditClick={this.onEditClick}
                onEditSave={this.onSave}
                onCreate={this.onCreate}
                onDeleteClick={this.onDeleteClick}

                items={this.state.subjects}
                editedItem={this.state.editingSubject}
                createdItem={this.state.creatingSubject}
              />
            )}
        </Panel>
      </>
    );
  }
}

export default FavoriteSubjects;